<app-editable-mbr-site-toolbar [instance]="this" [controls]="toolbarControlsForMasthead"
    [type]="ToolbarType.Global"></app-editable-mbr-site-toolbar>
<div class="site-masthead" id="nav">
    <nav class="navbar navbar-expand-lg navbar-light" [ngClass]="{ 'navbar-collapsed': isNavbarCollapsed }"
    id="nav-site-masthead">
        <div class="d-md-block">
            <app-masthead-logo [resourcestrings]="resourceStrings" (onCloseClick)="closemodalcross($event)">
            </app-masthead-logo>
        </div>
        <div class="navbar-toggler" data-target="#navbarsDefault" aria-controls="navbarsDefault">

            <i tabindex="0" [ngClass]="isNavbarCollapsed ? 'fa-bars' : 'fa-times'" class="fal focus-visibility"
                (click)="toggleNavBar()" (keyup.enter)="toggleNavBar()" role="button"
                [attr.aria-label]="resourceStrings['Aon.Arialabel.Toggle']"></i>
        </div>
        <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarsDefault">
            <ul class="head-menu navbar-nav ms-auto">
                <li ngbDropdown (openChange)="closeModelAddOverlay($event)"
                    class="nav-item-dropdown nav-li"
                    [attr.aria-label]='resourceStrings["Aon.Common.Profile.BenefitMenu"]'
                    [ngClass]="{ 'navbar-item-expanded': myBenefits.isOpen() }" #myBenefits="ngbDropdown"
                    [autoClose]="disableDropDownAutoClose ? false : dropDownAutoClose">
                    <a class="nav-link text-info focus-visibility" href="javascript:void(0)" id="dropdownBenefits"
                        (click)="closeOtherDropdowns(myBenefits)" [attr.aria-expanded]="myBenefits.isOpen()" role="button"
                        ngbDropdownToggle>
                        {{ resourceStrings["Aon.Common.Profile.BenefitMenu"] }}
                        @if (!myBenefits.isOpen()) {
                        <i class="float-end aon-icon aon-menu-collapse m-l-5  " aria-hidden="true"></i>
                        }
                        @if (myBenefits.isOpen()) {
                        <i class="float-end  aon-icon aon-angle-up m-l-5  " aria-hidden="true"></i>
                        }
                    </a>
                    <div ngbDropdownMenu aria-labelledby="dropdownBenefits" class="masthead-dropdown masthead-megamenu-dropdown">
                        <app-masthead-benefits [closeBenefit]="!myBenefits.isOpen()" [benefits]="mastheadService.benefits" [resourcestrings]="resourceStrings"
                            (collapseBenefitMenu)="myBenefits.close()" (dropdownState)="onToolbarDropdownState($event)" (refreshBenefitsEvent)="loadCategories()"></app-masthead-benefits>
                    </div>
                </li>
                <li class="nav-item nav-item-dropdown nav-li nav-li-login li-order-{{headMenuObject.profile}} anaval-profile">
                    <a class="nav-link text-info focus-visibility" role="link"
                        [attr.aria-label]="resourceStrings['Aon.SelfService.ArticleIndex']"
                        [routerLink]="[baseUrl + '/article/articleindex']">
                        <div class="icon-badge-container d-flex align-items-center">
                            <span [ngbTooltip]="resourceStrings['Aon.SelfService.ArticleIndex']" data-heap-redact-text>
                                {{resourceStrings['Aon.SelfService.ArticleIndex']}}
                            </span>
                        </div>
                    </a>
                </li>
                @if (authenticationService.isLogin && headMenuObject.profile) {
                <li ngbDropdown class="nav-item nav-li nav-li-login li-order-{{headMenuObject.profile}} anaval-profile"
                    [ngClass]="{ 'nav-item-dropdown': !helperService.AllowAnonymousAccess(), 'nav-item-menu': myUser.isOpen() }"
                    #myUser="ngbDropdown" [autoClose]="dropDownAutoClose">
                    <a class="nav-link text-info focus-visibility"
                        [attr.aria-label]="preferredName + ', ' + resourceStrings['Aon.Navigation.Profile']"
                        href="javascript:void(0)" (click)="closeOtherDropdowns(myUser)"
                        [attr.aria-expanded]="myUser.isOpen()" role="button" ngbDropdownToggle>
                        <div class="icon-badge-container d-flex align-items-center">
                            <i class="aon-icon aon-user d-flex" aria-hidden="true"></i><span
                                [ngbTooltip]="preferredName" data-heap-redact-text>
                                {{truncate(preferredName)}}@if ((isFailedPayment || hasGracePeriod)) {
                                <span class="badge bg-danger user-badge d-inline-block p-t-0 p-b-0 p-l-0 p-r-0"></span>
                                }
                            </span>

                        </div>
                    </a>

                </li>
                }
            </ul>
        </div>
    </nav>
</div>